import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import BEMHelper from '@ynap/bem-helper'
import PropTypes from 'prop-types'
import { Button } from '@ynap/button'
import { CombinedImage } from '@ynap/image'
import track from 'react-tracking'
import { trackTrackOrder, trackViewOrderDetails } from '../analytics'
import { withConfig } from '@ynap/immutables-provider'
import OrderItemStatus from './OrderItemStatus'

const bem = new BEMHelper('OrderItem')

const propTypes = {
    className: PropTypes.any,
    category: PropTypes.string,
    orderStatus: PropTypes.string,
    externalOrderID: PropTypes.string,
    displayId: PropTypes.string,
    orderType: PropTypes.string,
    placedDate: PropTypes.string,
    viewDetailLink: PropTypes.string,
    price: PropTypes.string,
    itemsNumber: PropTypes.string,
    trackingUrl: PropTypes.string,
    shippingMethod: PropTypes.array,
    image: PropTypes.string,
    rawOrderStatus: PropTypes.string,
    config: PropTypes.shape({
        alwaysShowOrderStatus: PropTypes.bool,
        deliveryTrackingEnabled: PropTypes.bool,
        imagesphereAspectRatio: PropTypes.string,
    }),
    messages: PropTypes.shape({
        orderItem: PropTypes.shape({
            orderId: PropTypes.func.isRequired,
            date: PropTypes.func.isRequired,
            price: PropTypes.func.isRequired,
            viewDetails: PropTypes.func.isRequired,
            trackExchange: PropTypes.func.isRequired,
            trackOrder: PropTypes.func.isRequired,
        }),
        orderDetails: PropTypes.shape({
            trackOrder: PropTypes.func.isRequired,
        }),
    }),
}

@withConfig((config) => ({
    alwaysShowOrderStatus: config?.head?.flags?.alwaysShowOrderStatus,
    deliveryTrackingEnabled: config?.head?.deliveryTrackingService?.enabled,
    imagesphereAspectRatio: config?.head?.aspectRatio?.imagesphere,
}))
@track({
    category: {
        subCategory: 'my orders',
    },
})
class OrderItem extends PureComponent {
    @track((props) => trackTrackOrder(props.category))
    handleTrackOrderClick = () => {}

    @track((props) => trackViewOrderDetails(props))
    handleViewOrderDetailsClick = () => {}

    render() {
        const {
            orderStatus,
            externalOrderID,
            displayId,
            orderType,
            placedDate,
            price,
            viewDetailLink,
            itemsNumber,
            className,
            messages,
            trackingUrl,
            shippingMethod,
            image,
            countryCode,
            rawOrderStatus,
            config: { alwaysShowOrderStatus = false, deliveryTrackingEnabled = false, imagesphereAspectRatio } = {},
        } = this.props

        const trackShippingButton = rawOrderStatus?.includes('Shipped') && !!trackingUrl && (
            <Button
                type="link"
                component="a"
                href={trackingUrl}
                target="_blank"
                rel="noreferrer noopener"
                className={bem('trackOrder')}
                onClick={this.handleTrackOrderClick}
            >
                {orderType?.toLowerCase() === 'exchange'
                    ? messages.orderItem.trackExchange()
                    : messages.orderItem.trackOrder()}
            </Button>
        )

        return (
            <div className={bem(null, null, className)}>
                <div className={bem('orderId')}>{messages.orderItem.orderId({ displayId })}</div>
                <div className={bem('date-price')}>
                    <time className={bem('placeDate')}>{messages.orderItem.date({ placedDate })}</time>
                    <p className={bem('price')}>{messages.orderItem.price({ price })}</p>
                </div>
                <div className={bem('container', orderStatus)}>
                    <div className={bem('imageContainer')}>
                        {orderStatus !== 'Pending' ? (
                            <Link
                                className={bem('image')}
                                to={viewDetailLink}
                                onClick={this.handleViewOrderDetailsClick}
                            >
                                <CombinedImage
                                    src={image}
                                    alt={externalOrderID}
                                    className={bem('image')}
                                    computeAttributes={false}
                                />
                            </Link>
                        ) : (
                            <div className={bem('image')}>
                                <CombinedImage
                                    src={image}
                                    alt={displayId}
                                    className={bem('image')}
                                    computeAttributes={false}
                                />
                            </div>
                        )}
                        {itemsNumber > 1 && <div className={bem('quantity')}>{`+${itemsNumber - 1}`}</div>}
                    </div>
                    <div className={bem('infoContainer')}>
                        {shippingMethod && <div className={bem('shippingMethod')}>{shippingMethod}</div>}
                        <OrderItemStatus
                            className={bem('status')}
                            externalOrderId={externalOrderID}
                            orderStatus={orderStatus}
                            countryCode={countryCode}
                            messages={messages}
                            trackShippingButton={trackShippingButton}
                            viewDetailLink={viewDetailLink}
                            alwaysShowOrderStatus={alwaysShowOrderStatus}
                            deliveryTrackingEnabled={deliveryTrackingEnabled}
                            orderType={orderType}
                            handleTrackOrderClick={this.handleTrackOrderClick}
                        />
                    </div>
                </div>
                {orderStatus !== 'Pending' && (
                    <div className={bem('links')}>
                        {alwaysShowOrderStatus && trackShippingButton}
                        <Link
                            className={bem('viewDetailsLink')}
                            to={viewDetailLink}
                            onClick={this.handleViewOrderDetailsClick}
                        >
                            {messages.orderItem.viewDetails()}
                        </Link>
                    </div>
                )}
            </div>
        )
    }
}

OrderItem.propTypes = propTypes

export default OrderItem
